import { render } from "./DestinationRowStatus.vue?vue&type=template&id=564fc471"
import script from "./DestinationRowStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationRowStatus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/DestinationRowStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "564fc471"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('564fc471', __exports__)) {
    api.reload('564fc471', __exports__)
  }
  
  module.hot.accept("./DestinationRowStatus.vue?vue&type=template&id=564fc471", () => {
    api.rerender('564fc471', render)
  })

}


export default __exports__